"use client";

import { c as _c } from "react/compiler-runtime";
import UniversalFilter from "@/components/filter-panel";
import { ProductListingFilterProps } from "@/components/filter-panel/types";
import { FilterPanelSkeleton } from "@/components/ui/skeleton";
import { useProductListingFilter } from "./hooks/useProductListingFilter";
const ProductListingFilterComponent = props => {
  const $ = _c(12);
  const {
    filterSchema,
    isNavbarLabel,
    onClearFilters,
    currentCategory,
    isLoadingState
  } = useProductListingFilter(props);
  if (isLoadingState) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <div className="h-full px-4 lg:px-0"><FilterPanelSkeleton /></div>;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  const t0 = currentCategory?.url;
  let t1;
  if ($[1] !== currentCategory?.id) {
    t1 = currentCategory?.id?.toString();
    $[1] = currentCategory?.id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== filterSchema || $[4] !== isNavbarLabel || $[5] !== onClearFilters || $[6] !== props.isCollection || $[7] !== props.onClose || $[8] !== props.searchParams || $[9] !== t0 || $[10] !== t1) {
    t2 = <UniversalFilter filterSchema={filterSchema} onClose={props.onClose} searchParams={props.searchParams} parentCategoryUrl={t0} parentItemId={t1} isCollection={props.isCollection} isNavbarLabel={isNavbarLabel} onClearFilters={onClearFilters} />;
    $[3] = filterSchema;
    $[4] = isNavbarLabel;
    $[5] = onClearFilters;
    $[6] = props.isCollection;
    $[7] = props.onClose;
    $[8] = props.searchParams;
    $[9] = t0;
    $[10] = t1;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
};
export default ProductListingFilterComponent;